"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _material = require("@mui/material");

var _Typography = require("../Typography");

var _Icon = require("../Icon");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "component", "openInNew", "color", "role", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledTypography = (0, _material.styled)(_Typography.Typography)(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "&.".concat(_utilities.classes.states.MuiFocusVisible), {
    border: "2px solid",
    borderColor: theme.palette.focusRing.main,
    borderRadius: "3px",
    boxShadow: "0 2px 4px rgba(93,176,255,0.5)",
    outline: 0,
    zIndex: 1
  }), (0, _defineProperty2.default)(_ref2, "&:hover", {
    textDecoration: "underline"
  }), (0, _defineProperty2.default)(_ref2, "textDecoration", "none"), _ref2;
});
var Link = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var children = _ref3.children,
      component = _ref3.component,
      openInNew = _ref3.openInNew,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? "primary" : _ref3$color,
      _ref3$role = _ref3.role,
      role = _ref3$role === void 0 ? "link" : _ref3$role,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? "inherit" : _ref3$variant,
      rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTypography, _objectSpread(_objectSpread({
    color: color,
    component: component || "a",
    ref: ref,
    rel: "noreferrer noopener",
    role: role,
    target: openInNew ? "_blank" : "_parent",
    variant: variant
  }, rest), {}, {
    children: [children, openInNew && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      iconName: "external-link-alt",
      ml: 1
    })]
  }));
});
var _default = Link;
exports.default = _default;